var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7896 2.21645L3.19351 5.99467L7.80976 7.57039C7.96096 7.6221 8.09845 7.70742 8.2119 7.81995C8.32534 7.93248 8.41178 8.06928 8.4647 8.22005L10.0783 12.8152L13.7896 2.21645ZM14.5871 0.0632576C15.4234 -0.235162 16.2324 0.569426 15.9384 1.40746L11.0765 15.2932C10.7464 16.2351 9.41278 16.236 9.08267 15.2932L6.91715 9.12587L0.715484 7.00877C-0.231711 6.68482 -0.240514 5.34942 0.701399 5.01402L14.5871 0.0632576Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.b755a88c9d31af26496b54d85ccb81ea.svg";
export { ForwardRef as ReactComponent };